import { render, staticRenderFns } from "./SepaList.vue?vue&type=template&id=f63267b4&scoped=true"
import script from "./SepaList.vue?vue&type=script&lang=js"
export * from "./SepaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63267b4",
  null
  
)

export default component.exports